import { useState } from "react";
import { Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import DstButton from "../../components/DstButton/DstButton";
import { DstLiveTable } from "../../components/DstTable/DstLiveTable";
import ListerSearch from "../../components/Lister/ListerSearch/ListerSearch";
import { useSession } from "../../contexts/SessionContext";
import { formatDateHumanly } from "../../services/TimeService";
import translate from "../../services/Translate";
import { completeNavigate } from "../../services/UtilityService";
import { generateRemoteUrl } from "./Diplomas.function";
import "./Diplomas.scss";

export const Diplomas = () => {
  const { language } = useSession();
  const navigate = useNavigate();
  const [fromDate, setfromDate] = useState<string>("");
  const [toDate, settoDate] = useState<string>("");
  const [searchDates, setSearchDates] = useState<any>({ from: null, to: null });
  const [searchQuery, setSearchQuery] = useState<string>("");

  const columns = [
    { name: translate(language, "PAGES.DIPLOMAS.ID"), key: "id", sortable: true },
    { name: translate(language, "PAGES.DIPLOMAS.NAME"), key: "name", sortable: true },
    { name: translate(language, "PAGES.DIPLOMAS.FILENAME"), key: "filename" },
    {
      name: translate(language, "PAGES.DIPLOMAS.CREATED_DATE"),
      key: "dt_created",
      sortable: true,
      render: (item: any) => (
        <span title={formatDateHumanly(language, item.dt_created, true)}>
          {formatDateHumanly(language, item.dt_created)}
        </span>
      ),
    },
    {
      name: translate(language, "PAGES.DIPLOMAS.UPDATED_DATE"),
      key: "dt_updated",
      sortable: true,
      render: (item: any) =>
        item?.dt_updated ? (
          <span title={formatDateHumanly(language, item.dt_updated, true)}>
            {formatDateHumanly(language, item.dt_updated)}
          </span>
        ) : (
          <span>-</span>
        ),
    },
  ];

  return (
    <div className="m-4">
      <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-3">
        <div className="d-flex align-items-center gap-3">
          <h2 className="mb-0">{translate(language, "PAGES.DIPLOMAS.TITLE")}</h2>
          <ListerSearch setSearchQuery={setSearchQuery} timeDelay={500} showSearchIcon />
        </div>
        <div className="d-flex justify-content-end">
          <DstButton
            btnImageBefore={<span className="me-2 dst-icon-download-03" />}
            value={translate(language, "PAGES.DIPLOMAS.IMPORT")}
            btnClass="me-2"
            variant="light"
            clickFunction={() =>
              completeNavigate({ ctrlKey: false, metaKey: false } as React.MouseEvent, navigate, "/diplomas/import")
            }
          />
        </div>
      </div>
      <div className="d-flex flex-wrap justify-content-end align-items-end gap-2 mb-3">
        <Form.Group className="mb-0">
          <Form.Label className="dark-gray-font xs-regular mb-1">
            {translate(language, "PAGES.DIPLOMAS.FROM_DATE")}
          </Form.Label>
          <Form.Control
            className="s-regular"
            type="date"
            value={fromDate}
            onChange={(e) => setfromDate(e.target.value)}
          />
        </Form.Group>
        <Form.Group className="mb-0">
          <Form.Label className="dark-gray-font xs-regular mb-1">
            {translate(language, "PAGES.DIPLOMAS.TO_DATE")}
          </Form.Label>
          <Form.Control className="s-regular" type="date" value={toDate} onChange={(e) => settoDate(e.target.value)} />
        </Form.Group>
        <div className="d-flex align-items-end">
          <DstButton
            clickFunction={() => {
              setSearchDates({ from: fromDate, to: toDate });
            }}
            value=""
            btnClass="py-2"
            btnImageBefore={<span className="dst-icon-search-md" />}
            tooltip={translate(language, "PAGES.MEETINGS.BUTTONS.APPLY_DATES")}
          />
          <DstButton
            clickFunction={() => {
              setfromDate("");
              settoDate("");
              setSearchDates({ from: null, to: null });
            }}
            value=""
            btnClass="py-2 ms-2"
            btnImageBefore={<span className="dst-icon-eraser" />}
            tooltip={translate(language, "PAGES.MEETINGS.BUTTONS.CLEAR_DATES")}
            variant="secondary"
          />
        </div>
      </div>
      <DstLiveTable
        classTable="text-nowrap"
        remote={generateRemoteUrl(searchDates.from, searchDates.to, searchQuery)}
        remoteKey="diplomas_list"
        columns={columns}
        pagination
        paginationAlwaysShowFooter
        paginationResizeOptions={[10, 50, 100]}
        onRowClick={(event, item) =>
          completeNavigate(event, navigate, `${process.env.REACT_APP_FILE_URL}/diploma/${item.filename}`)
        }
      />
    </div>
  );
};

export default Diplomas;
